import { render, staticRenderFns } from "./handPainted.vue?vue&type=template&id=3cd69950&"
import script from "./handPainted.vue?vue&type=script&lang=js&"
export * from "./handPainted.vue?vue&type=script&lang=js&"
import style0 from "./handPainted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports